// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment, CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment, CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment } from '../../designer/CharitableTrustDesigner/CharitableTrustDesignerAnalysis/graphql/CharitableTrustDesignerIllustrationData.generated';
import { gql } from '@apollo/client';
import { CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragmentDoc, CharitableTrustDesignerIllustrationData_CltProposalProjectionFragmentDoc, CharitableTrustDesignerIllustrationData_NoPlanProjectionFragmentDoc } from '../../designer/CharitableTrustDesigner/CharitableTrustDesignerAnalysis/graphql/CharitableTrustDesignerIllustrationData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCharitableProjectionQueryVariables = Types.Exact<{
  crtProjectionInput: Types.CrtProposalProjectionInput;
  cltProjectionInput: Types.CltProposalProjectionInput;
  noPlanProjectionInput: Types.NoPlanProjectionInput;
  isCRT: Types.Scalars['Boolean']['input'];
}>;


export type GetCharitableProjectionQuery = { __typename?: 'Query', crtProposalProjection?: (
    { __typename?: 'CRTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragment
  ), cltProposalProjection?: (
    { __typename?: 'CLTProposalProjection' }
    & CharitableTrustDesignerIllustrationData_CltProposalProjectionFragment
  ), noPlanProjection: (
    { __typename?: 'NoPlanProjection' }
    & CharitableTrustDesignerIllustrationData_NoPlanProjectionFragment
  ) };

export const Operations = {
  Query: {
    GetCharitableProjection: 'GetCharitableProjection' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetCharitableProjectionDocument = gql`
    query GetCharitableProjection($crtProjectionInput: CRTProposalProjectionInput!, $cltProjectionInput: CLTProposalProjectionInput!, $noPlanProjectionInput: NoPlanProjectionInput!, $isCRT: Boolean!) {
  crtProposalProjection(input: $crtProjectionInput) @include(if: $isCRT) {
    ...CharitableTrustDesignerIllustrationData_CRTProposalProjection
  }
  cltProposalProjection(input: $cltProjectionInput) @skip(if: $isCRT) {
    ...CharitableTrustDesignerIllustrationData_CLTProposalProjection
  }
  noPlanProjection(input: $noPlanProjectionInput) {
    ...CharitableTrustDesignerIllustrationData_NoPlanProjection
  }
}
    ${CharitableTrustDesignerIllustrationData_CrtProposalProjectionFragmentDoc}
${CharitableTrustDesignerIllustrationData_CltProposalProjectionFragmentDoc}
${CharitableTrustDesignerIllustrationData_NoPlanProjectionFragmentDoc}`;

/**
 * __useGetCharitableProjectionQuery__
 *
 * To run a query within a React component, call `useGetCharitableProjectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCharitableProjectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCharitableProjectionQuery({
 *   variables: {
 *      crtProjectionInput: // value for 'crtProjectionInput'
 *      cltProjectionInput: // value for 'cltProjectionInput'
 *      noPlanProjectionInput: // value for 'noPlanProjectionInput'
 *      isCRT: // value for 'isCRT'
 *   },
 * });
 */
export function useGetCharitableProjectionQuery(baseOptions: Apollo.QueryHookOptions<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>(GetCharitableProjectionDocument, withFetchPolicyContext(options));
      }
export function useGetCharitableProjectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>(GetCharitableProjectionDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetCharitableProjectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>(GetCharitableProjectionDocument, withFetchPolicyContext(options));
        }
export type GetCharitableProjectionQueryHookResult = ReturnType<typeof useGetCharitableProjectionQuery>;
export type GetCharitableProjectionLazyQueryHookResult = ReturnType<typeof useGetCharitableProjectionLazyQuery>;
export type GetCharitableProjectionSuspenseQueryHookResult = ReturnType<typeof useGetCharitableProjectionSuspenseQuery>;
export type GetCharitableProjectionQueryResult = Apollo.QueryResult<GetCharitableProjectionQuery, GetCharitableProjectionQueryVariables>;